class CarouselDots extends HTMLElement {
  dots;
  constructor() {
    super();

    this.generateDots();

    this.dots = this.querySelectorAll('li');
    if (this.dots.length) {
      this.dots[0].classList.add('bg-gray-600');

      document.addEventListener('custom:carousel:index', (ev) => {
        this.moveTo(ev.detail);
      });
    }
  }

  generateDots() {
    let dotsElement = document.createElement('ul');
    dotsElement.className = this.dataset.ulClass;
    let dotCount = document.querySelectorAll(`${this.dataset.list} > *`).length;

    for (let i = 0; i < dotCount; i++) {
      let li = document.createElement('li');
      li.className = this.dataset.liClass;
      dotsElement.appendChild(li);
    }

    this.appendChild(dotsElement);
  }

  moveTo(index) {
    this.dots.forEach((el) => el.classList.remove('bg-gray-600'));
    this.dots[index]?.classList.add('bg-gray-600');
  }
}

customElements.define('carousel-dots', CarouselDots);
